import React, { useState, useContext, useEffect } from 'react'
import i18n from 'live/services/i18n'
import LiveSpan from '../../Form/components/Content/LiveSpan'
import LiveModal from 'live/components/ui/Modal'
import type { ActionHeaderIconeProps, ActionHeaderProps } from './CardEditor/index'
import { PropsWidgetWrapper } from '../../Form/components/Content/types'
import { ReportContext } from '../../../src/app'
import updateReport from '../../api/updateReport'
import styled from 'styled-components'
import { CustomToolTip } from '../../common/components/CustomToolTip/CustomToolTip'
import { TemplateModal } from './ConfigLookupReplicationButton/styles'

export default function ContentGeneralSpan({ onHide }: ActionHeaderProps<PropsWidgetWrapper>): JSX.Element {
    const { report, dispatch } = useContext(ReportContext)
    const [span, setSpan] = useState<string>(report?.mailContent?.generalSpan)

    const onSave = () => {
        report.mailContent.generalSpan = span

        updateReport(report)
            .then(res => {
                dispatch({ report: res.config })
            })
            .finally(() => {
                onHide()
            })
    }

    return (
        <TemplateModal show={true} onHide={onHide} animation={false} className="modal-sm" isActive={true}>
            <TemplateModal.Header>
                <TemplateModal.Title>{i18n('Global timespan setting')}:</TemplateModal.Title>
            </TemplateModal.Header>
            <TemplateModal.Body>
                <LiveSpan
                    span={span}
                    useCaret={true}
                    setSpan={setSpan}
                    defaultSpan={null}
                    placeholder={i18n('Select an option...')}
                />
            </TemplateModal.Body>
            <TemplateModal.Footer>
                {/* <div>
                    <div><button className='btn btn-primary'></button></div>
                    <div><button className='btn btn-default'></button></div>
                </div> */}
                <TemplateModal.ModalActions
                    onSubmit={() => onSave()}
                    submitText={i18n('Apply')}
                    submitBtnClassName="btn btn-primary saveButton"
                    cancelBtnClassName="discardButton"
                    onCancel={onHide}
                    cancelText={i18n('Discard')}
                />
            </TemplateModal.Footer>
        </TemplateModal>
    )
}

export function ContentGeneralSpanIcon({ onClick }: ActionHeaderIconeProps): JSX.Element {
    const { report, dispatch } = useContext(ReportContext)
    const [span, setSpan] = useState<string>(null)

    useEffect(() => {
        setSpan(report?.mailContent?.generalSpan)
    }, [report?.mailContent?.generalSpan])

    return (
        <CustomToolTip
            tooltip={i18n(
                'By setting a global time span, all report content with a timespan will automatically adhere to it.'
            )}
            delayShow={500}
            delayHide={500}
            hasIcon={false}
        >
            <StyledGeneralSpanIcon onClick={() => onClick()}>
                <i className="generalSpanIcon--icon far fa-calendar-alt" />
                <div className="generalSpanIcon__span">
                    <span className="generalSpanIcon__span--description">{i18n('Global timespan:') + ' '}</span>
                    <span className="generalSpanIcon__span--spanValue">{span ?? i18n('no global timespan')}</span>
                </div>
            </StyledGeneralSpanIcon>
        </CustomToolTip>
    )
}

export const StyledGeneralSpanIcon = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    line-height: normal;
    padding: 4px 16px;
    border-radius: 3px;
    border: 1px solid ${({ theme }) => theme['blue-500']};

    .generalSpanIcon {
        &--icon {
            text-align: center;
            font-family: Font Awesome 5 Pro;
            font-style: normal;
            font-weight: 400;
            line-height: 16px; /* 145.455% */
            color: ${({ theme }) => theme['blue-700']};
            font-size: 11px;
        }
        &__span {
            display: inline;
            &--description {
                font-weight: 600;
            }
            &--spanValue {
                font-weight: 400;
            }
            &--spanValue,
            &--description {
                color: ${({ theme }) => theme['blue-700']};

                font-size: 13px;
                font-style: normal;
                font-family: ${({ theme }) => theme['font-regular']};
                line-height: 16px; /* 123.077% */
            }
        }
    }
    :hover {
        * {
            cursor: pointer;
        }
    }
`

const CustomLiveSpan = styled(LiveSpan)``
